import React, { useEffect } from "react";
import useAuthStore from "../store/authstore";
import { FrappeProvider } from "frappe-react-sdk";
import { routes } from "../routes";
import { useRoutes } from "react-router-dom";
import { useAuthContext } from "react-oauth2-code-pkce";
import useTokenExpireWatcher from "../hook/useAutoRefreshToken";

function MainComponent() {
  const token = useAuthStore((state) => state.token);
  const baseUrl = useAuthStore((state) => state.baseUrl);

  const logout = useAuthStore((state) => state.logout);
  function RouteLayout({ path }) {
    const element = useRoutes(path);
    return element;
  }
  const {
    login,
    token: oauthToken,
    loginInProgress,
    error,
    tokenData,
    idTokenData,
  } = useAuthContext();
  const setToken = useAuthStore((state) => state.setToken);
  const tokens = useAuthStore((state) => state.token);
  const ROCP_tokenExpire = localStorage.getItem("ROCP_tokenExpire");
  useTokenExpireWatcher(ROCP_tokenExpire);

  useEffect(() => {
    if (oauthToken) {
      setToken(oauthToken); // Save token to Zustand store
    }
  }, [oauthToken]);
  return (
    <FrappeProvider
      url={baseUrl}
      tokenParams={{
        useToken: true,
        // Pass a custom function that returns the token as a string - this could be fetched from LocalStorage or auth providers like Firebase, Auth0 etc.
        token: () => token || "",
        // This can be "Bearer" or "token"
        type: "Bearer",
      }}
      enableSocket={false}
      swrConfig={{
        revalidateOnFocus: false,
        revalidateOnMount: true,
        revalidateIfStale: false,
      }}
    >
      <RouteLayout path={routes()} />
    </FrappeProvider>
  );
}

export default MainComponent;
